export const INTEGRATE_SHOPIFY =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/SHOPIFY/INTEGRATE'
export const INTEGRATE_SHOPIFY_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/SHOPIFY/INTEGRATE_SUCCESS'
export const INTEGRATE_SHOPIFY_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/SHOPIFY/INTEGRATE_ERROR'
